import { Box } from "@mui/material";
import styled from "styled-components";

export const RescheduleScheduleStyled = styled(Box)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }

  .schedule-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .schedule-card {
    background-color: #fff;
    padding: 20px 24px;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .schedule-info {
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;
  }

  .schedule-actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .day-chips {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  .form-card {
    background-color: #fff;
    padding: 24px;
    border-radius: 20px;
    margin-bottom: 16px;
  }

  .form-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }

  .result-card {
    background-color: #fff;
    padding: 24px;
    border-radius: 20px;
    margin-top: 16px;
  }

  .result-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 8px;
  }

  .result-sections {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .result-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;
